import { useMemo } from 'react';
import { RATES_OPTIONS } from 'src/constants/reviews';
import { useReviewsCount } from 'src/store/hooks/reviews';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { StarFilled } from '@sravni/react-icons';

import styles from './rates-block.module.scss';

const ratesData = [RATES_OPTIONS.FIVE, RATES_OPTIONS.FOUR, RATES_OPTIONS.THREE, RATES_OPTIONS.TWO, RATES_OPTIONS.ONE];
const MAX_RATE = 5;

export const RatesBlock = () => {
  const { groupedByRatingValue: reviewsCount } = useReviewsCount();

  const totalCount = reviewsCount.reduce((sum, { reviewCount }) => sum + reviewCount, 0);

  const getRateBlock = useMemo(() => {
    if (!totalCount) return null;

    return (
      <div className={styles.wrapper}>
        {ratesData.map((item, i) => {
          const rate = MAX_RATE - i;

          const count = reviewsCount.find(({ ratingValue }) => ratingValue === rate)?.reviewCount || 0;
          const percent = Math.round((count / totalCount) * 100) || 0;

          return (
            <Space key={`rate-${item}`} size={8} align="center">
              <Space align="center" className={styles.starNumber}>
                <Typography.Text size={10} strong>
                  {rate}
                </Typography.Text>
                <Icon className={styles.icon} icon={<StarFilled />} color="orange" size={16} />
              </Space>
              <div className={styles.percentProgress}>
                <div className={styles.percentProgressInner} style={{ width: `${percent}%` }} />
              </div>
            </Space>
          );
        })}
      </div>
    );
  }, [reviewsCount, totalCount]);

  return getRateBlock;
};
